import {Component, OnInit} from '@angular/core';
import {BaseGiftCardTableComponent} from '../base-gift-card-table.component';

@Component({
    selector: 'bb-gift-cards',
    templateUrl: './gift-cards.component.html',
    styleUrls: ['./gift-cards.component.scss'],
})
export class GiftCardsComponent extends BaseGiftCardTableComponent implements OnInit {

}
